(function() { window.GUID_a4615da4_5448_4d73_ad34_1efd6b2a1595 = { getGuid: function() { return "a4615da4-5448-4d73-ad34-1efd6b2a1595"; } }; })();
var arrayOfUrlPopups = [];
function ShowFormPopup(getActionUrl, data, source, onPostCompleted, onClose, FullScreen, modal, popupInPopupName, freezedIds, onBeforePost) {
    var trackChanges = true;
    var frzedIds = null;
    if (freezedIds != null) {
        frzedIds = freezedIds.split(',');
    }
    if (modal == null) {
        modal = true;
    }
    if (arrayOfUrlPopups.indexOf(getActionUrl) == -1) {
        arrayOfUrlPopups.push(getActionUrl);
    }
    else {
        return;
    }
    //Ceci fait en sorte d'éviter que la popup tombe en cache
    if (getActionUrl.indexOf("?") > -1) {
        getActionUrl = getActionUrl + "&dummyDate=" + Date.now();
    }
    else {
        getActionUrl = getActionUrl + "?dummyDate=" + Date.now();
    }
    //Je crée le conteneur de la popup et j'abonne la touche Enter
    //pour ainsi soumettre le formulaire sur cette touche
    var container = null;
    container = $("<div>");
    var eventName = 'keydown.CSPopup';
    if (popupInPopupName != null && popupInPopupName != "") {
        eventName = eventName.replace('CSPopup', popupInPopupName);
    }
    CS.doc.on(eventName, function (e) {
        //e.preventDefault();
        //e.stopPropagation();
        var key = window.event ? e.keyCode : e.which;
        if (key == 13) {
            if (typeof container.AlreadyPosted == 'undefined') {
                container.AlreadyPosted = false;
                container.Source = source;
                container.onPostCompleted = onPostCompleted;
            }
            if (container.html() != "") {
                if (e.currentTarget.activeElement == null || e.currentTarget.activeElement.tagName != "TEXTAREA") {
                    if (container.find('.DoNothingOnEnter').length == 0) {
                        PostForm(container, "EnterKey");
                    }
                    e.preventDefault();
                }
            }
        }
    });
    if (data == null) {
        data = {};
    }
    var type = "GET";
    if (data != null && data.Post != 'undefined' && data.Post == true) {
        type = "POST";
    }
    if (data != null && data.post != 'undefined' && data.post == true) {
        type = "POST";
    }
    CompuSport.Ajax.Post(getActionUrl, data, function (result) {
        var buttonDefs = {};
        result = PathAttributes(result);
        container.append(result);
        container.Source = source;
        container.FormDialog = $('form', container);
        //container.FormDialog.append(CS.GetHiddenAntiforgertyToken()); 
        container.onPostCompleted = onPostCompleted;
        container.AlreadyPosted = false;
        var title = '';
        if (container.FormDialog.length > 0) {
            title = container.FormDialog[0].title;
            var buttonsStr = $(container.FormDialog).attr('data-buttons');
            if (buttonsStr != null) {
                var buttons = buttonsStr.split(",");
                $.each(buttons, function (index, value) {
                    var arraybuttons = value.split(";");
                    var title = arraybuttons[0];
                    var val = arraybuttons[1];
                    if (val.indexOf(':js:') > -1) {
                        container.off('keypress.CSPopup');
                    }
                    buttonDefs[title] = function () {
                        container.ClickedButton = title;
                        container.ClickedButtonIndex = index;
                        if (val.indexOf(':close:') > -1) {
                            $(this).dialog("close");
                        }
                        else if (val.indexOf(':post:') > -1) {
                            if (onBeforePost != null) {
                                onBeforePost.call(this);
                            }
                            PostForm(container, title);
                        }
                        else if (val.indexOf(':submit:') > -1) {
                            container.FormDialog.submit();
                        }
                        else if (val.indexOf(':redirect:') > -1) {
                            val = val.replace(':redirect:', '');
                            window.location.assign(decodeURIComponent(val));
                        }
                        else {
                            val = val.replace(':js:', '');
                            val = val.replace('|~|', ',');
                            eval(val);
                        }
                    };
                });
            }
        }
        else {
            buttonDefs['Close'] = function () {
                $(this).dialog("close");
            };
        }
        if (title == null) {
            title = '';
        }
        container.dialog({
            autoOpen: true,
            modal: modal,
            resizable: false,
            autoResize: true,
            width: 'auto',
            title: title,
            show: {
                effect: "slide",
                duration: 250
            },
            hide: {
                effect: "slide",
                duration: 250
            },
            buttons: buttonDefs,
            create: function (event, ui) {
                //Évite que sur les mobiles, lorsque je scroll avec le doigt, que les grid scroll derriere aussi
                $('.TableContainer').css('overflow', 'hidden');
                if (frzedIds != null) {
                    $(frzedIds).each(function (index, val) {
                        $('#' + val).css('overflow', 'hidden');
                    });
                }
                //Ici, j'évite d'affecter les grids qui sont dans la popup
                var gridInPopup = $('.TableContainer', container);
                gridInPopup.css('overflow', 'auto');
                ForceFullScreen($(this), FullScreen);
                var uiButtonSet = $('.ui-dialog-buttonset', $(this).parent());
                if (uiButtonSet.length > 0) {
                    uiButtonSet[0].id = 'UI-ButtonSet';
                }
                BindTrackChanges(container.FormDialog);
            },
            open: function () {
                CS.RefreshBehaviorOfScript(container.FormDialog);
                $(this).parent().promise().done(function () {
                    var data = {
                        container: container,
                        formDialog: container.FormDialog
                    };
                    CS.trigger('popup.shown', data);
                });
            },
            beforeClose: function (event, ui) {
                $('.TableContainer').css('overflow', 'auto');
                if (frzedIds != null) {
                    $(frzedIds).each(function (index, val) {
                        $('#' + val).css('overflow', 'auto');
                    });
                }
                if (onClose != null) {
                    return onClose.call(container);
                }
                if (typeof (container.FormDialog.OnClose) != 'undefined') {
                    container.FormDialog.OnClose.call(this);
                }
            },
            close: function () {
                CS.doc.off(eventName);
                var data = {
                    container: container,
                    formDialog: container.FormDialog
                };
                CS.trigger('popup.closed', data);
                $(this).empty();
                $(this).remove();
            }
        });
        arrayOfUrlPopups.pop( /*getActionUrl*/);
        return container;
    }, function () {
        arrayOfUrlPopups.pop( /*getActionUrl*/);
    });
    return container;
}
function BindTrackChanges(formDialog) {
    var trackChanges = false;
    if (formDialog.length > 0) {
        var trackChangesData = formDialog.data('trackchanges');
        trackChanges = trackChangesData == "true" || typeof (trackChangesData) == "undefined" ? true : false;
    }
    if (trackChanges) {
        $(formDialog).on('CSChange', function (e, element) {
            var csInput = $(e.target).closest('.CSInput');
            if (csInput.data('trackchanges') == "False") {
                return;
            }
            csInput.addClass('IsEdited');
            HighlightParentAccordionWhenEdited(csInput, formDialog);
            var multiEditCheckBox = $('.MultiEditCheckBox', csInput);
            multiEditCheckBox.off('change');
            multiEditCheckBox.on('change', function () {
                if (this.checked == false) {
                    csInput.removeClass('IsEdited');
                }
                else {
                    csInput.addClass('IsEdited');
                }
                HighlightParentAccordionWhenEdited(csInput, formDialog);
            });
            //Si je fais 
            var fgTweek = $('.FGTweek', csInput);
            if (fgTweek != null && fgTweek.length > 0) {
                fgTweek.val("true,false");
            }
            multiEditCheckBox.prop('checked', true);
            multiEditCheckBox.trigger('change');
        });
    }
}
function HighlightParentAccordionWhenEdited(actualCSInput, formDialog) {
    var accordionHeaders = $('.ui-accordion-header', formDialog);
    var parentAccordion = actualCSInput.closest('.ui-accordion-content');
    var parentHeaderAccordion = null;
    if (parentAccordion.length > 0) {
        $.each(accordionHeaders, function () {
            var header = $(this);
            if (header.attr('aria-controls') == parentAccordion[0].id) {
                parentHeaderAccordion = header;
            }
        });
    }
    if (parentHeaderAccordion != null) {
        if (parentAccordion.find('.CSInput.IsEdited').length > 0) {
            parentHeaderAccordion.addClass('IsEdited');
        }
        else {
            parentHeaderAccordion.removeClass('IsEdited');
        }
    }
}
function PostForm(container, pressedButton, forceResponseToFillForm) {
    if (forceResponseToFillForm == null) {
        forceResponseToFillForm = false;
    }
    var formDialog = $('form', container);
    //Ici, je detecte que si c'est une popup sans form, le post est impossible, donc, je referme après un click
    if (formDialog.length == 0) {
        container.dialog('close');
        return;
    }
    //Si le form est de type get, il n'est pas concu pour poster
    if (formDialog[0].method == "get") {
        return;
    }
    formDialog.append("<input name='PressedButton' type='hidden' value='" + pressedButton + "'/>");
    var url = formDialog.attr('action');
    //Le asyncMode fait en sorte que Chrome ne fait pas un popupblocker 
    //lorsque je veux afficher dans une nouvelle fenetre le pdf
    //Le principe est que Chrome, lorsqu'il détecte que code javascript
    //essaye d'afficher une fenetre apres un call async, il block automatiquement cette popup.
    //C'est pourquoi je roule en sync pour le print.
    var asyncMode = true;
    if (CSParameters.SportEventId != null && CSParameters.SportEventId != -1 && url != undefined) {
        if (url.indexOf("/" + CSParameters.SportEventId) == -1) {
            url += "/" + CSParameters.SportEventId;
        }
    }
    // if (formDialog.valid()) {
    if (container.AlreadyPosted == false || typeof container.AlreadyPosted == 'undefined') {
        container.AlreadyPosted = true;
        var jsonData = formDialog.serialize();
        //Remarque que ici, je n'utilise pas "ajaxAntiForgery", la raison est
        //que le antiforgerytoken est déjà inclu dans la sérialisation du formulaire 
        CompuSport.Ajax.Post(url, jsonData, function (response) {
            response = PathAttributes(response);
            if (container.onPostCompleted) {
                container.onPostCompleted.call(container, response, pressedButton);
            }
            if (response.returnUrl != null) {
                window.location.assign(decodeURIComponent(response.returnUrl));
            }
            else if (response.CSEntityState != null && response.htmlRows != null) {
                if (container.Source != null) {
                    let gridView = container.Source;
                    gridView.UpdateRowsFromPost(response);
                    container.dialog('close');
                }
            }
            else if (response.ForceRefreshOfGrid != null && response.ForceRefreshOfGrid == true) {
                if (container.Source != null) {
                    let gridView = container.Source;
                    gridView.RefreshGridData();
                }
                container.dialog('close');
            }
            else if (response.OverrideResult) {
                container.dialog('close');
            }
            else {
                //Ici, je recois la partial view de retour dans le cas ou il y a une erreur de validation
                $(container).empty().append(response);
                container.FormDialog = $('FORM', container);
                container.AlreadyPosted = false;
                //container.FormDialog.append(CS.GetHiddenAntiforgertyToken()); 
                if (container.FormDialog.length > 0) {
                    CS.RefreshBehaviorOfScript(container.FormDialog);
                    BindTrackChanges(container.FormDialog);
                    var firstErrorElement = $('.InError input', container.FormDialog).first();
                    if (firstErrorElement.length > 0) {
                        var data = {
                            formDialog: container.FormDialog,
                            formId: container.FormDialog[0].id,
                            firstErrorElementId: firstErrorElement == null ? null : firstErrorElement[0].id
                        };
                        CS.trigger('popup.error', data);
                    }
                }
                if (container.find(".NoSportEventIdError").length > 0) {
                    var uiButtonSet = $('.ui-dialog-buttonset', container.parent());
                    uiButtonSet.hide();
                }
                //}
            }
        }, function (xhr, status, error) {
            container.AlreadyPosted = false;
        });
    }
    /* }
     else {
         container.AlreadyPosted = false;
     }*/
}
function ForceFullScreen(dialog, fullScreen) {
    var windowW = CS.win.width();
    var windowH = CS.win.height();
    //view full screen mode
    var wFull = windowW - 50;
    var hFull = windowH - 50;
    var xLeft = Math.round((windowW / 2) - (wFull / 2));
    var yTop = Math.round((windowH / 2) - (hFull / 2));
    if (dialog != null && fullScreen) {
        dialog.dialog('option', 'width', wFull);
        dialog.dialog('option', 'height', hFull);
        dialog.dialog('option', 'position', [xLeft, yTop]);
    }
}
$.widget("ui.dialog", $.extend({}, $.ui.dialog.prototype, {
    _moveToTop: function () {
        return false;
    },
    _focusTabbable: function () {
        var firstTextbox = $(":text", this.uiDialog).first();
        if (firstTextbox != null && firstTextbox.length > 0 && !firstTextbox.hasClass('HasFocus') && firstTextbox.is(':visible')) {
            firstTextbox.focus();
            firstTextbox.select();
            firstTextbox.addClass('HasFocus');
        }
        else {
            if (!IsDefined(typeof (this.uiDialog.isLoaded))) {
                this.uiDialog.focus();
            }
        }
        this.uiDialog.isLoaded = true;
        return false;
    },
    _createOverlay: function () {
        if (!this.options.modal) {
            return;
        }
        // We use a delay in case the overlay is created from an
        // event that we're going to be cancelling (#2804)
        var isOpening = true;
        this._delay(function () {
            isOpening = false;
        });
        if (!this.document.data("ui-dialog-overlays")) {
            // Prevent use of anchors and inputs
            // Using _on() for an event handler shared across many instances is
            // safe because the dialogs stack and must be closed in reverse order
            this._on(this.document, {
                focusin: function (event) {
                    if (isOpening) {
                        return;
                    }
                    if (!this._allowInteraction(event)) {
                        event.preventDefault();
                        //C'est ici que j'ai fait un hack 
                        if (this._trackingInstances().length > 0) {
                            this._trackingInstances()[0]._focusTabbable();
                        }
                    }
                }
            });
        }
        this.overlay = $("<div>")
            .addClass("ui-widget-overlay ui-front")
            .appendTo(this._appendTo());
        this._on(this.overlay, {
            mousedown: "_keepFocus"
        });
        this.document.data("ui-dialog-overlays", (this.document.data("ui-dialog-overlays") || 0) + 1);
    },
}));
function PathAttributes(result) {
    if (typeof (result) == "string") {
        return result.replaceAll("data_", "data-");
    }
    return result;
}

//# sourceMappingURL=cs.popup.js.map
